import { useIsFavorite, useStationsStore } from '@app/core/stations/stores/stations.store';
import { theme } from '@mi-front/ui';
import { IconButton } from '@mui/material';
import StarRounded from '@mui/icons-material/StarRounded';
import StarBorderRounded from '@mui/icons-material/StarBorderRounded';
import classNames from 'classnames';

interface Props {
  stationId: string;
}

/**
 * Self-contained component for toggling station favorite status.
 * Uses the stations store to get favorite status and toggle it.
 */
export function FavoriteStationToggle(p: Props) {
  const { stationId } = p;
  const isFavorite = useIsFavorite(stationId);
  const toggleFavorite = useStationsStore((state) => state.toggleFavorite);

  return (
    <IconButton
      className={classNames('status-card__favorite-toggle', {
        'status-card__favorite-toggle--inactive': !isFavorite,
      })}
      onClick={(event) => {
        event.stopPropagation();
        toggleFavorite(stationId);
      }}
      size="small"
    >
      {isFavorite ? (
        <StarRounded sx={{ color: theme.aqua }} />
      ) : (
        <StarBorderRounded sx={{ color: 'action.disabled' }} />
      )}
    </IconButton>
  );
}
